import { SecondaryNavigationEntry } from 'components/navigation/secondary-nav-entry.js';
import { SectionContainer } from 'components/section-container.js';
import { SecondarySectionMain } from 'layout/sections/secondary-section/secondary-main.js';
import { useLayoutHeaderSections } from 'layout/sections/use-layout-header-sections.js';
import { ColumnLayoutContext } from 'page-context/column-layout/column-layout-context.js';
import { filterPrimaryConfig } from 'page/layout-areas.js';
import { memo, useContext, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { ILayoutConfig } from 'redux-state/layout/types.layout.js';
import { IRepoState } from 'redux-state/rootReducer.js';
import { PageLocationSummary } from 'types/markerTypes/location.page.js';
import { StickyBar } from '../layout-sticky-bar.js';
import { FiveUpPrimaryGridClasses } from './five-up-primary-grid-classes.js';
import { FiveUpPrimary } from './five-up-primary.js';

interface IStateProps {
  name: string;
  data: ILayoutConfig;
  location?: PageLocationSummary;
}

/**
 * Master Layout structure
 *  - contains various layout structures based on primary slots populated
 *  - - leftMajor, leftMinor, rightMajor, rightMinor, main, first
 *  - - passed module config from primary slots to cached modules previously loaded
 */
const FiveUpLayout = ({ data, name }: IStateProps) => {
  const { primary } = data;
  const columnLayout = useContext(ColumnLayoutContext);

  const filteredPrimaryConfig = useMemo(
    () => filterPrimaryConfig(primary.slots, columnLayout),
    [primary.slots, columnLayout],
  );

  const showPrimary = !!filteredPrimaryConfig.main.modules.length;
  const headers = useLayoutHeaderSections({ config: data, primary: filteredPrimaryConfig });

  // const useFullPageAdSidebar = UseIsChristchurch(columnLayout);

  if (!data) {
    return null;
  }

  return (
    <>
      <StickyBar name={name}>
        <>
          <SecondaryNavigationEntry />
          {headers}
          <SectionContainer
            dataModule="five-up-layout"
            className="u-flex u-flexGrow1"
            contentClassName="Container-inner Container-content"
            fill="gradient"
            padding={headers.length > 0 ? 'bottom' : 'all'}
            display={showPrimary}
          >
            <FiveUpPrimaryGridClasses navData={data.navigation}>
              <FiveUpPrimary data={data} />
            </FiveUpPrimaryGridClasses>
          </SectionContainer>
        </>
      </StickyBar>
      <SecondarySectionMain />
    </>
  );
};

const FiveUpMemoLayout = memo(FiveUpLayout);

export const FiveUpLayoutFinal = () => {
  const name = useSelector((state: IRepoState) => state.LAYOUT.screen.layout.name);
  const data = useSelector((state: IRepoState) => state.LAYOUT.screen.layout);
  const location = useSelector((state: IRepoState) => state.LAYOUT.screen.location);

  return <FiveUpMemoLayout name={name} data={data} location={location} />;
};
